<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <boolean-form-field
      :label="$t('network.fields.enabledForCreditAssignments')"
      required
      nullable
      :value="value.enabledForCreditAssignments"
      :error="findError('enabledForCreditAssignments')"
      :disabled="disabled"
      @input="propertyChange('enabledForCreditAssignments', $event)"
    />

    <boolean-form-field
      :label="$t('network.fields.enabledForMicroCredit')"
      required
      nullable
      :value="value.enabledForMicroCredit"
      :error="findError('enabledForMicroCredit')"
      :disabled="disabled"
      @input="propertyChange('enabledForMicroCredit', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
